<script lang="ts">
  import { router, type Route } from './router.svelte';
  import { settings } from '../state/settings.svelte';
  import BrowserNotice from './BrowserNotice.svelte';
  import LiveView from './LiveView.svelte';
  import AnalysisView from './AnalysisView.svelte';
  import SettingsPanel from './SettingsPanel.svelte';
  import SelfTest from './SelfTest.svelte';

  const tabs: { route: Route; label: string }[] = [
    { route: 'live', label: 'Live' },
    { route: 'analysis', label: 'Analysis' },
  ];

  $effect(() => {
    const root = document.documentElement;
    if (settings.theme === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', settings.theme);
  });
</script>

<BrowserNotice />

<header>
  <a class="brand" href={router.href('live')}>SoundLab</a>
  <nav aria-label="Main">
    {#each tabs as t (t.route)}
      <a
        href={router.href(t.route)}
        class="tab"
        aria-current={router.current === t.route ? 'page' : undefined}
        data-testid={`tab-${t.route}`}>{t.label}</a
      >
    {/each}
  </nav>
  <a
    class="tab settings"
    href={router.href('settings')}
    aria-current={router.current === 'settings' ? 'page' : undefined}
    data-testid="tab-settings">⚙ Settings</a
  >
</header>

<main>
  {#if router.current === 'live'}
    <LiveView />
  {:else if router.current === 'analysis'}
    <AnalysisView />
  {:else if router.current === 'settings'}
    <SettingsPanel />
  {:else if router.current === 'selftest'}
    <SelfTest />
  {/if}
</main>

<footer>
  <span>SoundLab <span data-testid="app-version">{__APP_VERSION__}</span></span>
  <span>All audio stays in this browser unless you export it.</span>
</footer>

<style>
  header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 0.5rem 1rem;
    background: var(--panel);
    border-bottom: 1px solid var(--border);
  }
  .brand {
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--text);
    text-decoration: none;
  }
  nav {
    display: flex;
    gap: 0.25rem;
    flex: 1;
  }
  .tab {
    padding: 0.35rem 0.9rem;
    border-radius: var(--radius);
    color: var(--text);
    text-decoration: none;
  }
  .tab:hover {
    background: var(--bg);
  }
  .tab[aria-current='page'] {
    background: var(--accent);
    color: var(--accent-text);
  }
  main {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
  }
  footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
    color: var(--muted);
    border-top: 1px solid var(--border);
  }
</style>
